import React from "react";
import {
    Container, Box, Divider, Typography, Grid,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import "../index.css";
import Breadcrumb from "../components/layout/Breadcrumb";
import { useTranslation } from 'react-i18next';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

const breadcrumbData = ["主頁", "會員", "會員名冊"];

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#c9bea8',
        color: '#000',
        fontSize: 18,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 16,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

function createData(memberId, companyName, contactPerson, phoneNumber, email, phoneNumber2 = '', email2 = '', website) {
    return { memberId, companyName, contactPerson, phoneNumber, email, phoneNumber2, email2, website };
  }
  
  const rows = [
    createData('GM00001','東淦工程有限公司','陳耀恒','(+852) 2386 7876','info@jumboorient.com.hk'),
    createData('GM00002','東研建築科技有限公司','黃逸郎','(+852) 2155 1838','kenny@jconstech.com'),
    createData('GM00003','保鋼工程有限公司','李世雄','(+852) 3145 0836','pro_eco@126.com'),
    createData('GM00004','煒浩工程有限公司','陳樹強','(+852) 3568 5141','info@waiholtd.com'),
    createData('GM00005','鍏歷馬建築管理有限公司','李可達','(+852) 3748 9183','info@wenama.com'),
    createData('GM00006','利生建築工程有限公司','陸偉林','(+852) 3996 7231','lisangsteel@gmail.com'),
    createData('GM00007','香港煌商佑鋼鐵實業有限公司','任艷軍','(+852) 2836 6968' ,'hkhuangshangyou@ulsteel.com', '(+852) 6556 1469','king@ulsteel.com'),
    createData('GM00008','豐業工程有限公司','蕭貝丰','(+852) 2388 8418','info@fitwellp.com'),
    createData('GM00009','金力鋼構有限公司','余智航','(+852) 3191 8700','admin@compass.com.hk'),
    createData('GM00010','邦輝工程有限公司','黃振添','(+852) 2633 6371','ericwong@bonfide-eng.com.hk'),
    createData('GM00011','鑑記金屬結構有限公司','Herbert Lau','(+852) 2971 3788','info@kamkee.hk'),
    createData('GM00012','梁湛記建築有限公司','黃子揚','(+852) 2395 1332','solutions@wolee.com'),
    createData('GM00013','竣煌有限公司','姜先生','(+852) 2151 4791','account@chunking.com.hk'),
    createData('GM00014','新立工程香港有限公司','何聲日','(+852) 3575 8829','info@sunlap-asia.com.hk', '', 'tender@sunlap-asia.com.hk'),
    createData('GM00015','中華行(香港)工程有限公司','鄧鈿澤','(+852) 2951 9898','info@chungwahhong.com.hk'),
    createData('GM00016','皓星工程有限公司','韓生','(+852) 2907 2226','honsang@honsang.com.hk'),
    createData('GM00017','佶鑫(亞太)建材有限公司','黃祟威','(+852) 2667 7318','info@ssllimited.com'),
    createData('GM00018','新麗工程(亞洲)有限公司','周海雄','(+852) 2787 6775','info@sunlaiasia.com.hk'),
    createData('GM00019','華騰鋼鐵工程有限公司','余汝華','(+852) 6050 2492','wahtensteel@gmail.com'),
    createData('GM00020','立花工程(香港)有限公司','Raymond Lau','(+852) 2403 4898','info@te.com.hk'),
    createData('GM00024','利亨土木工程有限公司','廖民匡','(+852) 9554 8816','info@leighhangcivil.ltd'),
    createData('GM00025','安成工程有限公司','陳國彬','(+852) 9209 3935','onshing9209@gmail.com'),
    createData('GM00026','寶發建設工程有限公司','余立安','(+852) 9038 3770','info@polyfair.corp.com.hk'),
    createData('GM00027','大龍國際有限公司','劉偉倫','(+852) 9270 7205','albert@masterdragon.com.hk'),
    createData('GM00028','易合企業有限公司','朱思旭','(+852) 9608 3762','admin@ehubsolar.net'),
    createData('GM00029','聯邦鋼鐵工程有限公司','區維真','(+852) 2690 3818','kongsinggroup@kong-sing.com'),
    createData('GM00031','東昇結構工程有限公司','黎瑞麟','(+852) 9103 8993','info@tungsingse.com.hk'),
    createData('GM00032','力豐營造有限公司','謝志光','(+852) 5544 7933','54044859h@gmail.com'),
    createData('GM00033','金磊工程有限公司','陳耀祖','(+852) 9491 8268','info.waeng@yahoo.com'),
    createData('GM00035','金源工程有限公司','張志成','(+852) 9277 2821','goldenresourceseng@grehk.com'),
    createData('GM00036','鉅城工程有限公司','岑惠強','(+852) 2387 8880','info@egoldenwall.com'),
    createData('GM00037','財記工程(香港)有限公司','伍民華','(+852) 9012 5315','andyng@cke.hk'),
    createData('GM00038','香港興業工程有限公司','朱章錦','(+852) 9187 6685','kevin.zhu@syeint.com'),
    createData('GM00039','東翹有限公司','姚易明','(+852) 9377 5298','vitus@glasslam-asia.com'),
    createData('GM00040','力堡工程(香港)有限公司','黃天偉','(+852) 2442 9235','colewong@mightfort.com.hk'),
    createData('GM00041','聯藝工程國際有限公司','--','--','--'),
    createData('GM00042','澳港建設(香港)有限公司','鄧建軍','(+852) 6570 0502','1052389281@qq.com'),
    createData('GM00043','順達工程發展(香港)有限公司','郭永忠','(+852) 9688 8670','hkshuntat@yahoo.com.hk'),
    createData('GM00044','鐵木新工程有限公司','莊小彬','(+852) 5599 2988','bennychuang@hk-egg.com'),
    createData('GM00045','建明建築工程有限公司','李志明','(+852) 2682 0022','kinmingconst@kinminghk.com'),
    createData('GM00046','億源建材有限公司','周碧蘇','(+852) 6110 3521','billionbuilding@yahoo.com.hk'),
    createData('GM00047','得力營造有限公司','譚志霖','(+852) 9717 4510','taklikco@gmail.com'),
    createData('GM00048','力新工程有限公司','何柏成','(+852) 6765 2931','liksun-admin@liksunenghk.com'),
    createData('GM00049','北海工程(香港)有限公司','梁振生','(+852) 2789 2398','northoceanhkcharles@yahoo.com.hk'),
    createData('GM00050','風順鋼鐵工程有限公司','余寶珍','(+852) 6188 4517','ansonhhww7@gmail.com'),
    createData('GM00051','恒豐鐵器工程有限公司','區廣權','(+852) 9713 1184','hf.metal@yahoo.com'),
    createData('GM00052','宏志建業公司','黃家奎','(+852) 9623 2116','minorworks812@yahoo.com'),
    createData('GM00053','盛世建築工程有限公司','陳海遠','(+852) 3704 7728','admin@goldenerahk.com'),
    createData('GM00054','創駿工程有限公司','吳沅鴻','(+852) 2191 2032','joeng.alphabest@gmail.com'),
    createData('GM00055','有信建築有限公司','--','--','--'),
    createData('GM00056','協興隆舞台工程有限公司','--','--','--'),
    createData('GM00057','至域有限公司','張伯龍','(+852) 3468 8634','info@cheerwin.com.hk'),
    createData('GM00058','何蘇工程有限公司','何礎銘','(+852) 2554 7192','hoso3388@yahoo.com.hk'),
    createData('GM00059','中興工程(香港)有限公司','陳兆俊','(+852) 2559 0999','info@chunghingc.com'),
    createData('GM00060','開寶工程有限公司 經營 樹記鐵工廠','王漢厚','(+852) 2323 0542','info@shukee.hk'),
    createData('GM00061','恒益捲閘工程有限公司','--','--','--'),
    createData('GM00062','滿利工程有限公司','姚滿棠','(+852) 2729 5698','ml@munleehk.com'),
    createData('GM00063','誠鑫工程有限公司','林開仁','(+852) 3956 8975','yan@sincerely.com.hk'),
    createData('GM00064','德寶土木工程有限公司','周淇','(+852) 2741 4851','tapbo@tapbo.com.hk'),
    createData('GM00065','凱順建築有限公司','鄭曉南','(+852) 9170 7055','hoishuncl@hotmail.com'),
    createData('GM00066','華建工程有限公司','謝誌釗','(+852) 2600 4078','hkeng@cgrand.com'),
    createData('GM00067','盈匯工程有限公司','GiGi Cheng','(+852) 2568 0068','info.jointfull@gmail.com'),
    createData('GM00068','誠興裝飾建材工程有限公司','黃進耀','(+852) 2726 2835','shinghingworkshop@yahoo.com.hk'),
    createData('GM00070','華達工程國際有限公司','魏志宏','(+852) 2720 4896','hungcheongeng@yahoo.com.hk'),
    createData('GM00071','萬基建築有限公司','林郁','(+852) 3611 5228','mankey@mkccl.com'),
    createData('GM00072','陳英鐵器工程有限公司','陳惠雄','(+852) 2669 7727','info@chanying.com'),
    createData('GM00073','高美建工程材料有限公司','陳兆寧','(+852) 2651 8223','info@mihltd.co'),
    createData('GM00074','恒興(香港)建築工程有限公司','陳佩芝','(+852) 2116 1943','info@hanghingshutter.com'),
    createData('GM00075','富盛工程(香港)有限公司','梁兆祐','(+852) 9488 1475','richly.engineering.hk@gmail.com'),
    createData('GM00077','銀同有限公司','劉雅婷','(+852) 2380 4968','enquiry@silvertown.hk'),
    createData('GM00078','聯營發展工程有限公司','何俊邦','(+852) 5300 0828','luenying711319@gmail.com'),
    createData('GM00079','東方創業發展有限公司','羅耀豪','(+852) 2177 1781','company@o-f.hk'),
    createData('GM00080','浩南工程有限公司','陳偉聲','(+852) 2155 1883','info@thf.hk'),
    createData('GM00081','恒記發展有限公司','倪耿林','(+852) 2191 8978','yung.hangkee@gmail.com'),
    createData('GM00082','翀達工程有限公司','王飛','(+852) 6355 8683','chungtat601@gmail.com'),
    createData('GM00083','昆玉機械工程有限公司','廖宏達','(+852) 2321 6782','kyhkjy@netvigator.com'),
    createData('GM00084','德恒建築發展有限公司','--','--','--'),
    createData('GM00085','應力工程有限公司','吳國威','(+852) 2401 2747','info@kpa.com.hk'),
    createData('GM00086','怡俊工程有限公司','雷兆鋒','(+852) 2126 7145','faithli@easysmart.com.hk'),
    createData('GM00087','湯馬士鋼鐵工程有限公司','黃俊榮','(+852) 2885 6883','mailadmin@noble-groups.com'),
    createData('GM00088','榮興鐵器有限公司','歐志明','(+852) 2382 0093','info@winghingltd.com.hk'),
    createData('GM00089','百利陶集團有限公司','蔡沛霖','(+852) 2455 6363','info@modenap.com'),
    createData('GM00090','中輝工程有限公司','張榮輝','(+852) 3996 8275','info@cbel.com.hk'),


  ];

  const rows2 = [
    createData('AM00001','泰興祥卡板包裝材料有限公司','陳嘉俊','(+852) 2674 6238','info@pallet.com.hk'),
    createData('AM00002',' 喜利得(香港)有限公司','譚志剛','(+852) 2773 4750','hksales@hilti.com'),
    createData('AM00003','匯賢建築材料國際有限公司','彭卓立','(+852) 9730 8379','contact@jambolts.com'),
    createData('AM00004','佰德有限公司','羅凱琪','(+852) 6989 6633','pcl@partec-ishimori.com'),
    createData('AM00005','鈞順(香港)建築材料有限公司','郭建雄','(+86) 180 3866 6361','hkgrandsource@163.com'),
    createData('AM00006','世昌鋁業(中國)有限公司','江龍應','(+852) 2110 2196','serene870@163.com'),
    createData('AM00007','港進建機服務中心有限公司','羅惠媚','(+852) 2488 6218','esther_law@kongchun.com.hk'),
    createData('AM00008','香港建旭測試服務有限公司','裔玉龍','(+852) 3686 2151','tiger.yi@jesee.com.cn', '(+852) 6854 1198'),
    createData('AM00009','香港黃埔產業科技有限公司','周銳','(+852) 5640 8841','chowray1001@gmail.com'),
    createData('AM00010','景灣工程有限公司','楊承熙','(+852) 2191 8336','yangbo@jinwanhk.com'),
    createData('AM00011','華測控股(香港)有限公司','林文灝','(+852) 2743 2128','hongkong@cti-cert.com'),
    createData('AM00012','伍爾特(香港)有限公司','嚴志達','(+852) 2750 8118','infohk@wuerth.cn', '(+852) 6890 2218', 'ivan.yim@wuerth.cn'),
    createData('AM00013','香港拓際有限公司','張勇','(+86) 134 1041 9569','zzk80@163.com'),
    createData('AM00014','翱豐五金有限公司','吳鐵山','(+852) 3704 7142','aofunghardware@gmail.com'),

  ];

  const rows3 = [
    createData('GMO00001','廣東唯楚建材有限公司','蕭宏圖','(+86) 138 2551 1943','gdvichu@163.com','','','www.vichu.com.cn'),
    createData('GMO00002','佛山市順德貝克達金屬制品有限公司','陳偉洪','(+86) 0757 2230 3988','chenwh@avancemetal.com','','','http://www.avancemetal.com/'),
    createData('GMO00003','佛山市南海桂城漢宏金屬制品廠','孫金柱','(+86) 139 2866 0420','hanhong_hzb@163.com','','','http://www.hanhonghk.com'),
    createData('GMO00004','廣東高麗鋁業有限公司','馮遠軍','(+86) 183 1681 6228','1972209271@qq.com','','','https://www.xingaoli.com'),
    createData('GMO00006','廣東海控特種玻璃技術有限公司','馮維','(+86) 1336 0265 8046','jamesfung@avicsgt.com','','','http://www.sanxinglass.com'),
    createData('GMO00007','惠州市友億工程建設有限公司','劉國友','(+86) 0752 3103 3356','liuguoyou29@163.com','','','--'),
    createData('GMO00008','深圳市天天圓金屬制品有限公司','張金雲','(+852) 6944 5109','zhang13538196952@163.com', '(+86) 135 3819 6952','','--'),
    createData('GMO00009','東莞市恒業幕牆材料有限公司','謝偉傳','(+86) 0769 8210 3868','hengye16888@163.com','','','--'),

  ];

function MemberListPage(props) {
    const { t, i18n } = useTranslation();

    return (
        <RootBox sx={{ minHeight: 'calc(100vh - 210px)' }}>
            <Root className={classes.root}>
                <Box sx={{ mt: { xs: 8.25, md: 12.5 } }}>
                    <Breadcrumb breadcrumbData={breadcrumbData} />
                </Box>
                {/* Noto Sans HK */}
                <Box sx={{ my: 2.5 }}>
                    <Typography variant="h4">{"會員名冊"}</Typography>
                </Box>
                <Box sx={{ my: 2 }}>
                    <Box sx={{ my: 1 }}>
                        <Typography variant="h6">
                            {'一般會員'}
                        </Typography>
                    </Box>
                    <TableContainer component={Paper}>
                        <Table aria-label="member table">
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell>編號</StyledTableCell>
                                    <StyledTableCell align="left">公司名稱</StyledTableCell>
                                    <StyledTableCell align="left">負責人</StyledTableCell>
                                    <StyledTableCell align="left">聯絡電話</StyledTableCell>
                                    <StyledTableCell align="left">電郵</StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            {rows.map((row) => (
                                <StyledTableRow key={row.memberId}>
                                <StyledTableCell component="th" scope="row">
                                    {row.memberId}
                                </StyledTableCell>
                                <StyledTableCell align="left">{row.companyName}</StyledTableCell>
                                <StyledTableCell align="left">{row.contactPerson}</StyledTableCell>
                                <StyledTableCell align="left">
                                    <div>
                                        {row.phoneNumber}
                                    </div>
                                    {row.phoneNumber2 && <div>{row.phoneNumber2}</div>}
                                </StyledTableCell>
                                <StyledTableCell align="left">
                                    <div>
                                        {row.email}
                                    </div>
                                    {row.email2 && <div>{row.email2}</div>}
                                </StyledTableCell>
                                </StyledTableRow>
                            ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Box sx={{ mt:2, mb: 1 }}>
                        <Typography variant="h6">
                            {'協同會員'}
                        </Typography>
                    </Box>
                    <TableContainer component={Paper}>
                        <Table aria-label="member table">
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell>編號</StyledTableCell>
                                    <StyledTableCell align="left">公司名稱</StyledTableCell>
                                    <StyledTableCell align="left">負責人</StyledTableCell>
                                    <StyledTableCell align="left">聯絡電話</StyledTableCell>
                                    <StyledTableCell align="left">電郵</StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            {rows2.map((row) => (
                                <StyledTableRow key={row.memberId}>
                                <StyledTableCell component="th" scope="row">
                                    {row.memberId}
                                </StyledTableCell>
                                <StyledTableCell align="left">{row.companyName}</StyledTableCell>
                                <StyledTableCell align="left">{row.contactPerson}</StyledTableCell>
                                <StyledTableCell align="left">
                                    <div>
                                        {row.phoneNumber}
                                    </div>
                                    {row.phoneNumber2 && <div>{row.phoneNumber2}</div>}
                                </StyledTableCell>
                                <StyledTableCell align="left">
                                    <div>
                                        {row.email}
                                    </div>
                                    {row.email2 && <div>{row.email2}</div>}
                                </StyledTableCell>
                                </StyledTableRow>
                            ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Box sx={{ mt: 2, mb: 1 }}>
                        <Typography variant="h6">
                            {'海外一般會員'}
                        </Typography>
                    </Box>
                    <TableContainer component={Paper}>
                        <Table aria-label="member table">
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell>編號</StyledTableCell>
                                    <StyledTableCell align="left">公司名稱</StyledTableCell>
                                    <StyledTableCell align="left">負責人</StyledTableCell>
                                    <StyledTableCell align="left">聯絡電話</StyledTableCell>
                                    <StyledTableCell align="left">電郵</StyledTableCell>
                                    <StyledTableCell align="left">網頁</StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            {rows3.map((row) => (
                                <StyledTableRow key={row.memberId}>
                                <StyledTableCell component="th" scope="row">
                                    {row.memberId}
                                </StyledTableCell>
                                <StyledTableCell align="left">{row.companyName}</StyledTableCell>
                                <StyledTableCell align="left">{row.contactPerson}</StyledTableCell>
                                <StyledTableCell align="left">
                                    <div>
                                        {row.phoneNumber}
                                    </div>
                                    {row.phoneNumber2 && <div>{row.phoneNumber2}</div>}
                                </StyledTableCell>
                                <StyledTableCell align="left">
                                    <div>
                                        {row.email}
                                    </div>
                                    {row.email2 && <div>{row.email2}</div>}
                                </StyledTableCell>
                                <StyledTableCell align="left">{row.website}</StyledTableCell>
                                </StyledTableRow>
                            ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </Root>
        </RootBox>
    )
}

const PREFIX = "member-list";

const classes = {
    root: `${PREFIX}-root`,
    loading: `${PREFIX}-loading`,
};


const Root = styled(Container)(({ theme }) => ({
    [`&.${classes.root}`]: {
        // width: '100%',
        backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
        height: '100%',
        background:
            theme.palette.mode === "dark"
                ? theme.palette.background.primary
                : "#fff",
        color:
            theme.palette.mode === "dark"
                ? "#fff"
                : theme.palette.text.primary,
        divider:
            theme.palette.mode === "dark"
                ? "#fff"
                : theme.palette.text.primary,
    },
    [`&.${classes.loading}`]: {
        height: '100vh',
        background:
            theme.palette.mode === "dark"
                ? theme.palette.background.primary
                : "#fff",
        color:
            theme.palette.mode === "dark"
                ? "#fff"
                : theme.palette.text.primary,
        divider:
            theme.palette.mode === "dark"
                ? "#fff"
                : theme.palette.text.primary,
    },
}));

const RootBox = styled(Box)(({ theme }) => ({
    background: theme.palette.mode === 'dark'
        ? '#1A2027'
        : `linear-gradient(rgba(255,255,255,0.9), rgba(255,255,255,0.9)), url('img/bg.png')`,
    variant: 'outlined',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'left',
    color: theme.palette.text.primary,
}));

const Title = (props) => {
    return (
        <Box sx={{ my: 2, flexGrow: 1, display: { xs: 'flex', md: 'flex' } }}>
            <Grid container spacing={{ xs: 1, md: 2 }} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Grid item xs={12} sm={12} md={12}
                    container
                    spacing={0}
                    direction="row"
                    justifyContent={props.position ? props.position : "center"}
                >
                    <Typography
                        variant="h4"
                        component="div"
                        sx={{ fontWeight: 'bold' }}
                    >
                        {props.title}
                    </Typography>
                </Grid>
            </Grid>
        </Box>
    )
}

const SubTitle = (props) => {
    return (
        <Box sx={{ my: 2, flexGrow: 1, display: { xs: 'flex', md: 'flex' } }}>
            <Grid container spacing={{ xs: 1, md: 2 }} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Grid item xs={12} sm={12} md={12}
                    container
                    spacing={0}
                    direction="row"
                    justifyContent={props.subtitle ? props.subtitle : "center"}
                >
                    <Typography
                        variant="subtitle1"
                        component="div"
                        sx={{ fontWeight: 'bold' }}
                    >
                        {props.subtitle}
                    </Typography>
                </Grid>
            </Grid>
        </Box>
    )
}

const CustomDivider = styled(Divider)(({ theme }) => ({
    [`&.about`]: {
        background:
            theme.palette.mode === "dark"
                ? theme.palette.primary.main
                : '#7A5D26',
        borderBottomWidth: 3,
        width: "100%"
        // marginBottom: 10
    },
    [`&.companyBusiness`]: {
        background:
            theme.palette.mode === "dark"
                ? theme.palette.primary.main
                : '#7A5D26',
        borderBottomWidth: 2,
        width: "5%"
        // marginBottom: 10
    },

}));

const ScaleCard = styled(Box)(({ theme }) => ({
    "&:hover": {
        transition: "transform 0.5s ease-in-out",
        transform: "scale3d(1.05, 1.05, 1)"
    },
}));

export default MemberListPage;
